module.exports = __webpack_public_path__ + "static/media/JSN5299.bd9a4aef.jpg";